import { render, staticRenderFns } from "./RecentArticles.vue?vue&type=template&id=cc00af1a&scoped=true&"
import script from "./RecentArticles.vue?vue&type=script&lang=js&"
export * from "./RecentArticles.vue?vue&type=script&lang=js&"
import style0 from "./RecentArticles.vue?vue&type=style&index=0&id=cc00af1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc00af1a",
  null
  
)

export default component.exports